  import React, { useEffect, useState } from 'react';
  import { useParams, Link } from 'react-router-dom';
  import { db } from './firebase';
  import { doc, getDoc } from 'firebase/firestore';
  import './FotoDetail.css';

  const FotoDetail = () => {
    const { id } = useParams();
    const [photoData, setPhotoData] = useState(null);
    const [mainImage, setMainImage] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
      const fetchPhoto = async () => {
        try {
          const docRef = doc(db, 'fotos', id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            setPhotoData(data);
            setMainImage(data.images?.[0] || '');
          } else {
            setError('Photo not found.');
          }
        } catch {
          setError('Error fetching photo data.');
        } finally {
          setLoading(false);
        }
      };

      fetchPhoto();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    const handleThumbnailClick = (index) => {
      setMainImage(photoData.images[index]);
    };

    return (
      <div className={`photo-detail-container ${!photoData.title && !photoData.description ? 'centered' : ''}`}>
        <Link to="/" className="back-link">Terug</Link>
    
        <div className={`photo-detail-left ${!photoData.title && !photoData.description ? 'full-center' : ''}`}>
          <img
            className="main-image"
            src={mainImage}
            alt={photoData.title || 'Untitled'}
            loading="lazy"
          />
          <div className="thumbnail-row">
            {photoData.images && photoData.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={photoData.title || 'Untitled'}
                className="thumbnail"
                onClick={() => handleThumbnailClick(index)}
                loading="lazy"
              />
            ))}
          </div>
        </div>
    
        {photoData.title || photoData.description ? (
          <div className="photo-detail-right">
            {photoData.title && <h2 className="title">{photoData.title}</h2>}
            {photoData.description && <p className="description">{photoData.description}</p>}
          </div>
        ) : null}
      </div>
    );
  }    

  export default FotoDetail;
